import Select from 'react-select';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { TailSpin } from "react-loader-spinner";
import { Funnel } from "@phosphor-icons/react";
import { Link, useLocation } from 'react-router-dom';


import { get, post } from '../../services/api';
import { logout } from '../../auth';
import { parseObjectToURLQuery } from '../../utils';

import AdminSection from "../AdminSection/AdminSection";
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect';

import '../CadastroMetas/CadastroMetas.css';
import '../ListarCluster/listarCluster.css';

export default function GerenciarCluster() {
    const navigate = useNavigate()
    const location = useLocation();
    
    //Usado para trazer os dados da tela de listar cluster
    const [idClusterListar, setIdClusterListar] = useState(location.state?.idClusterListar || null);
    const [descricaoClusterListar, setDescricaoClusterListar] = useState(location.state?.descricaoClusterListar || null);

    const authToken = localStorage.getItem('adminToken');

    const [ optionsRegiao, setOptionsRegiao ] = useState([]);
    const [ clustersSelecionados, setClustersSelecionados ] = useState(null);
    const [ optionsCluster, setOptionsCluster ] = useState([]);
    const [ regiaofilialDisponivel, setRegiaofilialDisponivel ] = useState([]);
    const [ regiaofilialSelecionada, setRegiaofilialSelecionada ] = useState([]);

    const [ abreRegiaoSelectDisponivel, setRegiaoSelectDisponivel ] = useState(false);
    const [ abreRegiaoSelectSelecionado, serRegiaoSelectSelecionado ] = useState(false);
    
    const [ filialSelecionada, setfilialSelecionada ] = useState([]);
    const [ filialDisponivel, setfilialDisponivel ] = useState([]);
    const [ filialSelecionadaInteiro, setfilialSelecionadaInteiro ] = useState([]);
    const [ filialDisponivelInteiro, setfilialDisponivelInteiro ] = useState([]);

    const [ selectedfilialDisponivel, setSelectedfilialDisponivel ] = useState([]);
    const [ selectedfilialSelecionada, setSelectedfilialSelecionada ] = useState([]);
    
    const [ selectedClusterLabel, setSelectedClusterLabel ] = useState('');
    const [ isFetchingSalvarFiliaisCluster, setIsFetchingSalvarFiliaisCluster ] = useState(false);

       //Usado para que o filtro de regiao funcione nos valores vindo da tela de listarCluster
       useEffect(() => {
        if(idClusterListar) {
            setSelectedClusterLabel(descricaoClusterListar);
            setClustersSelecionados({ label: descricaoClusterListar, value: idClusterListar });
            getfilialCluster({label: descricaoClusterListar, value: idClusterListar});
        }
    }, [idClusterListar, descricaoClusterListar]);

    async function setOptionsClusterWithRequest(authToken) {
        try {
            const clusters = await get('/admin/metas/cluster', null, authToken)
            setOptionsCluster(clusters.map(cluster => ({ 
                label: cluster.cluster, 
                value: cluster.id_cluster 
            })))

            return clusters
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsRegiaoWithRequest(authToken) {
        try {
            const regioes = await get(`/admin/metas/regiao?${parseObjectToURLQuery({
                habilitadas: 'false'
            })}`, null, authToken);


            const options = [
                ... regioes.map(regiao => ({ 
                    label: regiao.nome_regiao, 
                    value: regiao.id_regiao 
                }))
            ];

            setOptionsRegiao(options);

            return regioes;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    function cancelarCluster() {
        setfilialSelecionada([]);
        setfilialDisponivel([]);
        setfilialSelecionadaInteiro([]);
        setfilialDisponivelInteiro([]);
        setSelectedfilialDisponivel([]);
        setSelectedfilialSelecionada([]);
        setClustersSelecionados([]);
        setSelectedClusterLabel([]);
        setRegiaofilialDisponivel([]);
        setRegiaofilialSelecionada([]);
        setRegiaoSelectDisponivel(false);
        serRegiaoSelectSelecionado(false);
        setIdClusterListar(null);
        setDescricaoClusterListar(null);
    }

    async function salvarCluster() {

        try {

            const requisicao = {  cluster: clustersSelecionados.value, dadosfilial: filialSelecionadaInteiro };

            setIsFetchingSalvarFiliaisCluster(true);

            const response = await post('/admin/cluster/salvarclusters', requisicao, authToken);

            setIsFetchingSalvarFiliaisCluster(false);

            if (!response.Sucesso) {
                toast.error(response.Mensagem);
                return;
            }

            getfilialCluster(clustersSelecionados);
            toast.success(response.Mensagem);
        } catch (error) {
            cancelarCluster();
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function getfilialCluster(cluster) {
        try {

            const response = await post('/admin/cluster/gerenciarcluster', cluster, authToken);

            setfilialSelecionadaInteiro(response.filialCluster);
            setfilialDisponivelInteiro(response.filialDisponivel);
            setfilialSelecionada(response.filialCluster);
            setfilialDisponivel(response.filialDisponivel);

        } catch (error) {
            cancelarCluster();
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    const removerfilial = () => {
        const filialParaRemover = filialDisponivel.filter(filial => selectedfilialDisponivel.includes(filial.idfilial));
        setfilialSelecionada(filialSelecionada.concat(filialParaRemover));
        setfilialDisponivel(filialDisponivel.filter(filial => !selectedfilialDisponivel.includes(filial.idfilial)));
        setfilialSelecionadaInteiro(filialSelecionadaInteiro.concat(filialParaRemover));
        setfilialDisponivelInteiro(filialDisponivelInteiro.filter(filial => !selectedfilialDisponivel.includes(filial.idfilial)));
        setSelectedfilialDisponivel([]);
    };

    const adicionarfilial = () => {
        const filialParaAdicionar = filialSelecionada.filter(filial => selectedfilialSelecionada.includes(filial.idfilial));
        setfilialDisponivel(filialDisponivel.concat(filialParaAdicionar));
        setfilialSelecionada(filialSelecionada.filter(filial => !selectedfilialSelecionada.includes(filial.idfilial)));
        setfilialDisponivelInteiro(filialDisponivelInteiro.concat(filialParaAdicionar));
        setfilialSelecionadaInteiro(filialSelecionadaInteiro.filter(filial => !selectedfilialSelecionada.includes(filial.idfilial)));
        setSelectedfilialSelecionada([]);
    }

    const handleClusterChange = (cluster) => {
        setClustersSelecionados(cluster);
        setSelectedClusterLabel(cluster ? cluster.label : '');
        getfilialCluster(cluster); 
    };

    const abreSelectRegiao = (filial) => {

        if(filial == 1) {
            setRegiaoSelectDisponivel(!abreRegiaoSelectDisponivel);
            serRegiaoSelectSelecionado(false); 
        } else {
            serRegiaoSelectSelecionado(!abreRegiaoSelectSelecionado);
            setRegiaoSelectDisponivel(false);
        }
    };
    
    const filterfilial = (selectedRegiao, filialList) => {
        if (selectedRegiao.length === 0) {
            return filialList;
        }
        return filialList.filter((filial) =>
            selectedRegiao.some((regiao) => regiao === filial.idregiao)
        );
    };

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }

        setOptionsRegiaoWithRequest(authToken)
        setOptionsClusterWithRequest(authToken);

        setfilialDisponivel(filterfilial(regiaofilialDisponivel, filialDisponivelInteiro));
        setfilialSelecionada(filterfilial(regiaofilialSelecionada, filialSelecionadaInteiro));

    }, [regiaofilialDisponivel, regiaofilialSelecionada])

    return <>
        <AdminSection
            etapa={1} titulo={'Selecione os Filtros'}  
            
            acoes={<>
               <Link className='criar-cluster-btn' to="/admin/cluster/editarcluster">Criar Cluster</Link>
            </>}
        >
            <div className='animal-first-values'>
                <div className='first-values-right'>
                    <div className='id_cluster-wrapper'>
                        <label htmlFor="id_cluster">Selecione o cluster</label>
                        <Select
                            name="cluster"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={clustersSelecionados}
                            onChange={(cluster) => { 
                                handleClusterChange(cluster)

                                getfilialCluster(cluster)
                            }}
                            options={optionsCluster}
                            placeholder="Cluster"
                            required
                            isSearchable={false}
                            menuShouldScrollIntoView={false} 
                        />
                    </div>
                </div>
            </div>
            
        </AdminSection>
        <AdminSection
            etapa={2} titulo={'Gerenciar Cluster'} 
        >
            <div className="flex justify-center items-center gerenciar-cluster">
                <div className="flex flex-col gap-4 items-center lg:flex-row">
                    <div className="flex flex-col">
                        <div className='filial-regiao-select'>
                            <label>Adicionar filial</label>
                            <button className='filtro-regiao' onClick={() => abreSelectRegiao(1)}>
                                <Funnel size={16} />
                            </button>
                        </div>
                        <div className='show-select'>{abreRegiaoSelectDisponivel && (
                            <div className='multi-select-regiao'> 
                                <CustomMultiSelect
                                    selectedOptions={regiaofilialDisponivel}
                                    setSelectedOptions={setRegiaofilialDisponivel}
                                    filteredOptions={optionsRegiao}
                                    placeholder={'Selecione a Região'}
                                />
                            </div>
                        )}
                        </div>
                        <select multiple className="form-multiselect block w-80 h-64 p-2 border border-gray-300 rounded-md overflow-auto whitespace-normal"
                            value={selectedfilialDisponivel}
                            onChange={e => setSelectedfilialDisponivel(Array.from(e.target.selectedOptions, option => Number(option.value)))}>
                            {Array.isArray(filialDisponivel) && filialDisponivel.map((filial, index) => (
                                <option key={index} value={filial.idfilial}>{(filial.idfilial - 10000) + ' - ' + filial.nomefilial}</option>
                            ))}
                        </select>
                    </div>

                    <div className="flex flex-col justify-center space-y-2">
                        <button onClick={removerfilial} className="remover-adicionar-btn">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                        </button>
                        <button onClick={adicionarfilial} className="remover-adicionar-btn">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
                        </button>
                    </div> 

                    <div className="flex flex-col">
                        <div className='filial-regiao-select'>
                            <label>{selectedClusterLabel ? `Cluster: ${selectedClusterLabel}` : 'Selecione o cluster'}</label>
                            <button className='filtro-regiao' onClick={() => abreSelectRegiao(2)}><Funnel size={16} /></button> 
                        </div>
                        <div className='show-select'>{abreRegiaoSelectSelecionado && (
                            <div className='multi-select-regiao'> 
                                <CustomMultiSelect
                                    selectedOptions={regiaofilialSelecionada}
                                    setSelectedOptions={setRegiaofilialSelecionada}
                                    filteredOptions={optionsRegiao}
                                    placeholder={'Selecione a Região'}
                                />
                            </div>
                        )}
                        </div>
                        <select multiple className="form-multiselect block w-80 h-64 p-2 border border-gray-300 rounded-md overflow-auto whitespace-normal"
                            value={selectedfilialSelecionada}
                            onChange={e => setSelectedfilialSelecionada(Array.from(e.target.selectedOptions, option => Number(option.value)))}>
                            {Array.isArray(filialSelecionada) && filialSelecionada.map((filial, index) => (
                                <option key={index} value={filial.idfilial}>{(filial.idfilial - 10000) + ' - ' + filial.nomefilial}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            
            <div className='animal-metas-buttons' style={{paddingBottom: '25px'}}>
                <button onClick={cancelarCluster} className='animal-refresh-btn'>Cancelar</button>
                <button onClick={salvarCluster} className='animal-save-btn'>
                    {isFetchingSalvarFiliaisCluster ? (
                        <div className='salvar-button'>
                            <TailSpin color="#ffffff" height={20} width={39} />
                        </div>
                    ) : (
                        "Salvar"
                    )}

                </button>
            </div>
            <ToastContainer />
        </AdminSection>
    </>
}
